// extracted by mini-css-extract-plugin
export default {"action":"ActionButton_action__58xyD","neutral":"ActionButton_neutral__S4Fwq","danger":"ActionButton_danger__m0ljK","gold":"ActionButton_gold__O4sRF"};